export function sectionTitleId(title: string) {
  return `dashboard-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`
}
